import { Show } from "solid-js";
import { styles } from "../styles";

type Props = {
  open: boolean;
  onToggleOpen: () => void;
};

export function HelpPanel(props: Props) {
  return (
    <div class={styles.popoverRoot}>
      <button
        class={styles.headerButton}
        type="button"
        title="使い方"
        aria-label="使い方"
        aria-expanded={props.open}
        aria-controls="help-panel"
        onClick={props.onToggleOpen}
      >?</button>
      <Show when={props.open}>
        <section id="help-panel" class={`${styles.popover} ${styles.helpPopover}`} aria-label="使い方">
          <header class={styles.popoverHeader}>
            <strong class={styles.popoverTitle}>使い方</strong>
            <button class={styles.popoverCloseButton} type="button" aria-label="使い方を閉じる" onClick={props.onToggleOpen}>✕</button>
          </header>

          <p class={styles.helpLead}>
            本アプリの利用によって生じたトラブル、不利益または不都合について、当方では責任を負いかねます。内容をご理解のうえ、自己責任でご利用ください。
          </p>

          <p class={styles.helpLead}>
            本アプリはPWAに対応しています。アプリを開いているページで、ブラウザのメニューから「ホーム画面に追加」や「アプリをインストール」などを選択することで、ホーム画面からアプリのように使用できて便利です。PWAは便利なのでもっと流行って欲しいと思っています。
          </p>

          <div class={styles.helpGrid}>
            <section class={styles.helpSection}>
              <h2>コーデ選択</h2>
              <ul>
                <li>コーデのパーツ画像を押すと選択・解除できます。長押しすると画像を拡大できます。</li>
                <li>右下の「🗒」から選択内容を確認し、同じパーツの候補を切り替えられます。</li>
                <li>名前検索、データ検索、色検索で候補を絞り込めます。</li>
              </ul>
            </section>

            <section class={styles.helpSection}>
              <h2>ミックスコーデ</h2>
              <ul>
                <li>各コーデから使いたいパーツを選び、「🗒」で組み合わせを確認します。</li>
                <li>スプレッドシート登録後は、名前とブランドを指定して現在の組み合わせを保存できます。</li>
                <li>保存した組み合わせは画面下の「ミックス」から確認できます。</li>
              </ul>
            </section>

            <section class={styles.helpSection}>
              <h2>フレンドカード</h2>
              <ul>
                <li>画面下の「フレンド」で、登録したフレンドカードを一覧表示できます。</li>
                <li>「登録」からプレイヤー名などを入力し、カメラでQRを読み取って保存します。</li>
                
                <li>コーデやミックスコーデを紐づけると、コーデ詳細画面からも確認できるようになります。紐づけは後から変更できます。</li>
              </ul>
            </section>

            <section class={`${styles.helpSection} ${styles.helpSetupSection}`}>
              <h2>Googleスプレッドシートの準備</h2>
              <div class={styles.helpSetupIntro}>
                コーデの閲覧・検索・選択は設定なしで使えます。Googleスプレッドシートを登録すると、所持状況やQR、ミックスコーデ、フレンドカードを保存できます。
              </div>
              <ol>
                <li><a href="https://docs.google.com/spreadsheets/" target="_blank" rel="noopener noreferrer">Googleスプレッドシート</a>で新しいファイルを作成します。</li>
                <li><code>check</code> と <code>qr</code> という名前のシートを作成します。ミックスコーデを保存する場合は <code>mix</code> も作成します。</li>
                <li>共有設定を「リンクを知っている全員」「編集者」に変更します。</li>
                <li>スプレッドシートのURLまたはIDを、右上の「⚙️」に入力して「保存・再読込」を押します。</li>
                <li><code>friend</code> シートは、最初のフレンドカード登録時に自動作成されます。</li>
              </ol>
              <p class={styles.helpNotice}>登録後は、所持状況の記録、自分のQRの登録・表示、ミックスコーデとフレンドカードの保存ができます。共有リンクを知る人が編集できる設定になるため、スプレッドシートIDを誰にも知られないよう管理にご注意いただくとともに、気になる方は利用をお控えください。</p>
            </section>
          </div>
        </section>
      </Show>
    </div>
  );
}
